import React from "react";
import { api } from "../api";

export const useDiscountValidation = checkoutId => {
  const [discount, setDiscount] = React.useState(null);
  const [validating, setValidating] = React.useState(false);

  const validateDiscount = async email => {
    try {
      setValidating(true);
      const { data } = await api.post(
        `checkout/${checkoutId}/validate_discount`,
        { email }
      );
      setValidating(false);

      if (data?.valid === true) {
        const validatedDiscount = {
          valid: true,
          discount_amount: data.discount_amount,
          installments: data.installments,
          checkout_payment_types_available:
            data.checkout_payment_types_available,
        };
        setDiscount(validatedDiscount);

        return validatedDiscount;
      }

      setDiscount(null);

      return { valid: false };
    } catch (error) {
      setValidating(false);
      setDiscount(null);

      return { valid: false };
    }
  };

  const resetDiscount = () => setDiscount(null);

  return { discount, validating, validateDiscount, resetDiscount };
};
